import { updateDialog } from '@Containers/Dialogs/DialogsActions';
import { typeOfUserAgreementPrompt } from './UserAgreementPromptConstants';

// eslint-disable-next-line import/prefer-default-export
export function openProfileSettingsUserAgreementPrompt(props) {
  return (dispatch) => {
    dispatch(
      updateDialog({
        id: typeOfUserAgreementPrompt,
        dialogType: typeOfUserAgreementPrompt,
        ...props,
      })
    );
  };
}
